import React, { useEffect } from "react";
import "./styles";
import { ModosImportacaoContainer } from "./styles";
import { produtosApi } from "../../../hooks/produtosApi";
import { Link, useParams } from "react-router-dom";
import ImportarImagens from "../ImportarImagens/ImportarImagens";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import Swal from "sweetalert2";

interface ModosImportacaoProps {
  permissoesPlanos: string[];
}

const ModosImportacao: React.FC<ModosImportacaoProps> = ({
  permissoesPlanos,
}) => {
  const { theme } = useTheme();

  const ProdutosApi = produtosApi();
  const [loading, setLoading] = React.useState(false);
  const [modos, setModos] = React.useState<
    { id: string; titulo: string; descricao: string }[]
  >([]);
  const [modoAtivo, setModoAtivo] = React.useState<{
    id: string;
    titulo: string;
    descricao: string;
  } | null>(null);

  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    const init = async () => {
      const response = await ProdutosApi.getModosImportacao();
      setModos(response);
    };

    init();
  }, []);

  useEffect(() => {
    if (id) {
      const modo = modos.find((modo) => modo.id === id);
      if (modo) {
        setModoAtivo(modo);
      }
    } else {
      setModoAtivo(null);
    }
  }, [id, modos]);

  useEffect(() => {
    if (permissoesPlanos.length! && permissoesPlanos["IMPORTACAO_DE_MULTIPLAS_FOTOS"]?.permitido) {
      Swal.fire({
        icon: "warning",
        title: "Acesso negado",
        text: "Você não tem permissão para acessar essa página",
      }).then(() => {
        setTimeout(() => {
          window.location.href = "/";
        }, 5000);
      });
    }
  }, [permissoesPlanos]);

  if (!permissoesPlanos["IMPORTACAO_DE_MULTIPLAS_FOTOS"]?.permitido) {
    return null;
  }

  return (
    <ModosImportacaoContainer theme={theme}>
      <div className="modos-container">
        <div className={`tipo ${!modoAtivo && "ativo"}`}>
          {modos.map((modo) => (
            <Link
              to={`/painel/produtos/importar-imagens/${modo.id}`}
              className={`modo-container 
                        ${!modoAtivo && "ativo"}
                        ${modoAtivo?.id === modo.id && "ativo-modo"}`}
              onClick={() => {
                setModoAtivo(modo);
              }}
            >
              <div className="titulo fonteSubtitulo">{modo.titulo}</div>
              <div
                className="descricao fonteTexto"
                dangerouslySetInnerHTML={{ __html: modo.descricao }}
              ></div>
            </Link>
          ))}
        </div>
        {modoAtivo && (
          <>
            <div className="tipo ativo">
              <div className={`modo-container ativo`}>
                <div className="titulo fonteSubtitulo">{modoAtivo.titulo}</div>
                <div
                  className="descricao fonteTexto"
                  dangerouslySetInnerHTML={{ __html: modoAtivo.descricao }}
                ></div>
              </div>
              <ImportarImagens modo={modoAtivo}></ImportarImagens>
            </div>
          </>
        )}
      </div>
    </ModosImportacaoContainer>
  );
};

export default ModosImportacao;
